<template>
  <v-main
    v-if="videos && videos.length"
    class="px-0 pt-5"
  >
    <div class="title mb-3 d-flex justify-space-between">
      <span>Video</span>
    </div>

    <v-row>
      <v-col
        v-for="(video, vKey) in videos"
        :key="vKey"
        cols="12"
        sm="6"
        lg="4"
        @click="previewVideo(video.id)"
      >
        <v-img
          v-if="video.thumbnail"
          :src="video.thumbnail"
          height="180"
        >
          <template #placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              />
            </v-row>
          </template>

          <v-row
            align="end"
            class="lightbox px-3 fill-height"
          >
            <v-col>
              <div class="body-1 pa-1 white--text">
                {{ video.name }}
              </div>
            </v-col>
          </v-row>
        </v-img>

        <div
          v-else
          class="lightbox d-flex align-end"
          style="position: relative; width: 100%; height: 180px;"
        >
          <div
            class="d-flex justify-center align-center"
            style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
          >
            <v-icon x-large>
              play_circle_outline
            </v-icon>
          </div>

          <v-col>
            <div class="body-1 pa-1 white--text">
              {{ video.name }}
            </div>
          </v-col>
        </div>
      </v-col>
    </v-row>

    <VideoPreview
      :dialog.sync="dialogPreview"
      :selected="selected"
      :videos="videos"
    />
  </v-main>
</template>

<script>
import resourceApi from '@/api/coach-profile/resource';
import videoInspector from '@/mixins/videoInspector';

import VideoPreview from './VideoPreview.vue';

export default {
  name: 'Video',

  components: {
    VideoPreview,
  },

  mixins: [videoInspector],

  props: {
    showError: {
      type: Boolean,
      default: false,
    },

    section: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    videos: null,
    dialogPreview: false,
    selected: 0,
  }),

  mounted() {
    this.getVideo();
  },

  methods: {
    async getVideo() {
      try {
        const response = await resourceApi.getVideo(this.section.id);

        if (response && response.length) {
          const filtered = await Promise.all(
            response.map(async (item) => {
              let thumbnail = '';
              let server = 1;

              if (item.main_video_link) {
                thumbnail = await this.getVideoThumbnail(item.main_video_link);
              }

              if (!thumbnail) {
                thumbnail = await this.getVideoThumbnail(item.fallback_video_link);
                server = 2;
              }

              if (!thumbnail) {
                thumbnail = '';
                server = 1;
              }

              return { ...item, thumbnail, server };
            }),
          );

          this.videos = filtered;
        }
      } catch (err) {
        console.log('Video get', err);
        if (err.key && ['noSubscription'].includes(err.key)) {
          this.$emit('update:showError', true);
        } else {
          this.$toast.error(err.msg);
        }
      }
    },

    previewVideo(id) {
      this.selected = id;
      this.dialogPreview = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  .lightbox {
    cursor: pointer;
    box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, transparent 72px);
  }
</style>
